import { useEffect, useState } from "react";
import axios from "axios";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Lightbulb, ChevronDown, ChevronUp } from "lucide-react";
import { motion } from "framer-motion";
import { API } from "@/App";

const ConceptionTipsCard = () => {
  const [tips, setTips] = useState([]);
  const [expanded, setExpanded] = useState(null);

  useEffect(() => {
    axios.get(`${API}/wellness/ttc/tips`)
      .then(res => setTips(res.data.tips || []))
      .catch(() => setTips([]));
  }, []);

  const grouped = tips.reduce((acc, t) => {
    (acc[t.category] = acc[t.category] || []).push(t);
    return acc;
  }, {});

  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.24 }}
      data-testid="conception-tips-card"
    >
      <Card className="glass">
        <CardHeader className="pb-3">
          <CardTitle className="text-white flex items-center gap-2">
            <Lightbulb className="w-5 h-5 text-amber-300" />
            Conception Tips
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-3">
          {Object.entries(grouped).map(([cat, items]) => (
            <div key={cat}>
              <p className="text-amber-200/80 text-xs uppercase tracking-wider mb-2">{cat}</p>
              <div className="space-y-1">
                {items.map((t, idx) => {
                  const key = `${cat}-${idx}`;
                  const open = expanded === key;
                  return (
                    <button
                      key={key}
                      onClick={() => setExpanded(open ? null : key)}
                      className="w-full text-left rounded-lg bg-mystic-900/40 border border-white/5 hover:border-mystic-400/30 transition-colors overflow-hidden"
                      data-testid={`tip-${cat.toLowerCase()}-${idx}`}
                    >
                      <div className="flex items-center justify-between p-3">
                        <span className="text-white text-sm font-medium">{t.title}</span>
                        {open ? <ChevronUp className="w-4 h-4 text-mystic-300" /> : <ChevronDown className="w-4 h-4 text-mystic-300" />}
                      </div>
                      {open && (
                        <div className="px-3 pb-3 text-mystic-200/80 text-xs leading-relaxed">{t.body}</div>
                      )}
                    </button>
                  );
                })}
              </div>
            </div>
          ))}
        </CardContent>
      </Card>
    </motion.div>
  );
};

export default ConceptionTipsCard;
